import { listTypesId } from '../../../utils/constants';
import { getListType } from '../../../utils/helpers';
import ProductionListForm from './ProductionListForm';
import TestListForm from './TestListForm';

const ListForms = () => (getListType() === listTypesId.TEST_LIST ? <TestListForm /> : <ProductionListForm />);

export default ListForms;
